import React from 'react';
import {
  Route,
  Redirect,
  RouteProps,
} from 'react-router-dom';
import AuthUtils from '../shared/utils/auth-utils';

interface PrivateRouteProps extends RouteProps {
  children: JSX.Element,
  path: string | string[],
}

const PrivateRoute = (props: PrivateRouteProps) => {
  const { children, path, ...other } = props;

  return (
    <Route
      path={path}
      render={() => (AuthUtils.isAuth() ? (
        <>
          {children}
        </>
      ) : (
        <Redirect
          to={{ pathname: '/login' }}
        />
      ))}
      {...other}
    />
  );
}

export default PrivateRoute;